import ReactDOM from "react-dom"
import {RouterProvider, createBrowserRouter} from "react-router-dom"
import { INewsletterSettings, NewsletterSettingsDefaults } from "./context/NewsletterSettingsContext";
import App from './App';

declare global {
  interface Window {
    CreateNewsletterWidget: (settings: INewsletterSettings) => void
  }
}

enum ConsoleType {
	Error,
	Trace,
	Info,
	Warning,
}

function getScriptURL(): string {
    const url = document?.currentScript?.getAttribute("src") || "";
    if (!url) return "";
    let a = document.createElement("a");
    a.href = url;
    return a.protocol + "//" + a.host + "/";
}

declare var __webpack_public_path__: string;
__webpack_public_path__ = getScriptURL();
if (process.env.NODE_ENV === 'development') {
  console.log("script URL:", ConsoleType.Trace, __webpack_public_path__);
}

window.CreateNewsletterWidget = function (settings: INewsletterSettings = NewsletterSettingsDefaults) {

	settings.newsletterID ??= NewsletterSettingsDefaults.newsletterID
	settings.floating ??= NewsletterSettingsDefaults.floating
	settings.darkmode ??= NewsletterSettingsDefaults.darkmode
	settings.background ??= NewsletterSettingsDefaults.background
	settings.buttonColor ??= NewsletterSettingsDefaults.buttonColor
	
	const router = createBrowserRouter([
		{
		  path: "*",
		  element: <App NewsletterSettings={settings}/>,
		},
	  ]);

  const container = document.querySelector('.newsletterWidget');

  ReactDOM.render(
	<RouterProvider router={router}/>
, container)
}